import { useFestivalShopStore } from './festivalShop'
import { useLocaleStore } from './locale'
import { useMeStore, persistKey as mePersistKey } from './me'
import { useNotificationStore } from './notification'
import { useNotificationCenterStore } from './notificationCenter'
import { useTopProductsRankingCompareStore, persistKey as comparePersistKey } from './topProductsRankingCompare'

const resetAllStores = () => {
  useNotificationCenterStore().reset()
  useTopProductsRankingCompareStore().reset()
  localStorage.removeItem(comparePersistKey)
  return [mePersistKey].forEach((key) => sessionStorage.removeItem(key))
}

export {
  useFestivalShopStore,
  useLocaleStore,
  useMeStore,
  useNotificationCenterStore,
  useNotificationStore,
  useTopProductsRankingCompareStore,
  resetAllStores,
}
